<template>
	<div class="us_confirm_wrapper" :class="{'us_confirm_wrapper_out': !visible }" v-show="show">
    <div class="us_confirm_overlay"></div>
		<v-card class="us_confirm_dialog" :class="{'us_confirm_dialog_out': !visible }">
			<v-card-title>{{options.title}}</v-card-title>
			<v-card-text>
				{{options.content}}
			</v-card-text>
			<v-card-actions>
        <v-btn color="#43A047" style="width:40%;height:2.75rem;" text @click="ok">确定</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="#1E88E5" style="width:40%;height:2.75rem;" text @click="cancel">取消</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>
<script>
export default {
  data() {
    return {
      promiseStatus: null,
      show: false,
      options: {
        title: '提示',
        content: ''
      },
      visible: false
    }
  },
  methods: {
    confirm(options) {
      const _this = this;
      _this.show = true;
      _this.visible = true;
      // console.log('options', options);
      if (options && options.title) {
        _this.options.title = options.title
      }
      if (options && options.content) {
        _this.options.content = options.content
      }
      return new Promise(function(resolve, reject) {
        _this.promiseStatus = { resolve, reject };
      });
    },
    ok() {
      var that = this
      that.visible = false;
      setTimeout(function() {
        that.show = false;
      }, 500)
      that.promiseStatus && that.promiseStatus.resolve();
    },
    cancel() {
      var that = this
      that.visible = false;
      setTimeout(function() {
        that.show = false;
      }, 500)
      that.promiseStatus && that.promiseStatus.reject();
    }
  }
}
</script>
<style scoped>
	.us_confirm_wrapper{
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0px;
    pointer-events: none;
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 6;
    /* transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1) 0s, z-index 1ms ease 0s; */
    animation: fadeIn 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
    outline: none;
    transform: scale(1);
  }

  .us_confirm_wrapper_out{
    animation: fadeOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
  }

	.us_confirm_dialog{
		overflow-y: auto;
		pointer-events: auto;
		width: 100%;
		z-index: inherit;
		box-shadow: rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px;
		border-radius: 4px;
    margin: 24px;
    animation: roadRunnerIn 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
		/* transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s; */
		max-width:290px;
  }

  .us_confirm_dialog_out{
    animation: roadRunnerOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
  }

	.us_confirm_overlay{
		align-items: center;
		border-radius: inherit;
		display: flex;
		justify-content: center;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		pointer-events: auto;
		/* background:#000;
		opacity:0.46; */
  }

@keyframes fadeIn {
  0% {
    background: rgba(0, 0, 0, 0);
  }
  100% {
    background: rgba(0, 0, 0, 0.7);
  }
}
@keyframes fadeOut {
  0% {
    background: rgba(0, 0, 0, 0.7);
  }
  100% {
    background: rgba(0, 0, 0, 0);
  }
}

@keyframes roadRunnerIn {
  0% {
    transform: translateX(-1500px) skewX(30deg) scaleX(1.3);
  }
  70% {
    transform: translateX(30px) skewX(0deg) scaleX(0.9);
  }
  100% {
    transform: translateX(0px) skewX(0deg) scaleX(1);
  }
}
@keyframes roadRunnerOut {
  0% {
    transform: translateX(0px) skewX(0deg) scaleX(1);
  }
  30% {
    transform: translateX(-30px) skewX(-5deg) scaleX(0.9);
  }
  100% {
    transform: translateX(1500px) skewX(30deg) scaleX(1.3);
  }
}

@keyframes quickScaleDown {
  0% {
    transform: scale(1);
  }
  99.9% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}

.us_confirm_dialog /deep/ .v-card__title{
  font-size: 1.1rem;
  padding-bottom: 8px;
}

</style>
